<template>
  <v-dialog
    class="text-left"
    v-model="isOpenDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar class="fixed-bar" dark flat color="primary">
        <v-btn icon dark @click="closeDialog()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Add new shop</v-toolbar-title>
      </v-toolbar>

      <v-col cols="12">
        <v-form ref="shopForm" :model="form">
          <!-- <v-col cols="12"> -->
          <v-text-field
            label="Shop name"
            v-model="form.name"
            :rules="nameRules"
          />
          <v-text-field
            itemid="code"
            label="Shop code"
            v-model="form.code"
            disabled
            :rules="codeRules"
          />
          <v-select
            :items="shopClass"
            label="Select shop class"
            item-text="name"
            item-value="id"
            v-model="form.class_id"
            :rules="classRules"
          >
          </v-select>
          <v-select
            label="Select distributor"
            :items="distributors"
            item-text="name"
            item-value="id"
            v-model="form.distributor_id"
           
          ></v-select>
          <v-select
            label="Location"
            :items="locations"
            item-text="name"
            item-value="id"
            v-model="form.location_id"
            :rules="locationRules"
          ></v-select>
          <div class="text-right">
            <v-btn
              color="black"
              outlined
              small
              depressed
              class="text-capitalize"
              @click="handleOpenAddLocation()"
            >
              <v-icon left> mdi-plus </v-icon>
              Add new location
            </v-btn>
          </div>
          <v-text-field
            label="Phone number"
            v-model="form.phone"
            :rules="phoneRules"
          />
          <v-text-field label="GST" v-model="form.gst" :rules="gstRules" />
          <v-select
            label="Select User"
            :items="user"
            item-text="name"
            item-value="id"
            v-model="form.user_id"
            :rules="userRules"
          ></v-select>
          <div class="text-right">
            <v-btn
              color="black"
              outlined
              small
              depressed
              class="text-capitalize"
              @click="openUserForm"
            >
              <v-icon left> mdi-plus </v-icon>
              Add new user
            </v-btn>
          </div>
          <br />
          <div class="d-flex flex-row justify-space-between">
          <v-btn style="width:48%" color="primary" @click="createShop">Create</v-btn>
         
          <v-btn style="width:48%" @click="closeDialog()">Cancel</v-btn>
          </div>
          <!-- </v-col> -->
        </v-form>

        <v-snackbar v-model="snackbar" timeout="2500" color="primary"
          >{{ snackbar_message }}
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>

        <!-- <v-snackbar
          v-model="snackbarLocation"
          timeout="2500"
          color="error"
          :snackbarDialog.sync="snackbarLocation"
          >{{ snackbar_location_message }}
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar> -->

        <v-snackbar v-model="snackbaruser" timeout="3000" color="primary"
          >{{ snackbar_user }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="snackbaruser = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
      <AddLocation :dialog.sync="addLocationDialog" />
    </v-card>
    <v-dialog v-model="isUserModal">
      <v-card>
        <v-toolbar class="fixed-bar" dark flat color="primary">
          <v-toolbar-title>Add new User</v-toolbar-title>
        </v-toolbar>

        <v-col cols="12">
          <v-form ref="formUser" :model="userm">
            <v-col cols="12">
              <v-text-field label="User Name" v-model="userm.name" :rules="unameRules" />
              <v-text-field label="Email" v-model="userm.email" :rules="emailRules" />

              <v-text-field
                label="Password"
                v-model="userm.password"
                :rules="passwordRules"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              />

          <div class="d-flex flex-row justify-space-between">
          <v-btn style="width:48%" color="primary" @click="handleAddUser">Create</v-btn>
         
          <v-btn style="width:48%" @click="isUserModal=false" >Cancel</v-btn>
          </div>
            
            </v-col>
          </v-form>
          <v-snackbar v-model="snackuservalid" timeout="2500" color="error"
            >{{ snackvalid_message }}
            <template v-slot:action="{ attrs }">
              <v-btn color="white" text v-bind="attrs" @click="snackuservalid = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </v-col>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import AddLocation from "./_addLocation";
export default {
  components: {
    AddLocation,
  },
  props: ["dialog"],
  data() {
    return {
      message: false,
      showPassword: false,
      form: {},
      userm: {},
      isUserModal: false,
      user: [{}],
      code: {},
      shopClass: [{}],
      distributors: [{}],
      locations: [{}],
      addLocationDialog: false,
      snackbar: false,
      // snackbarLocation: false,
      // snackbar_location_message: "Location added succesfully",
      snackbaruser: false,
      snackuservalid: false,
      snackbar_user: "User added succesfully",
      snackbar_message: "Shop added succesfully",
      snackvalid_message: "Name or email already exist",
      nameRules: [(v) => !!v || "Shop name is required"],
      phoneRules: [(v) => !!v || "Phone number is required"],
      codeRules: [(v) => !!v || "Shop code is required"],
      classRules: [(v) => !!v || "Please select a class"],
      distributorRules: [(v) => !!v || "Please select a distributor"],
      locationRules: [(v) => !!v || "Please select a location"],
      gstRules: [(v) => !!v || "Phone number is required"],
      userRules: [(v) => !!v || "Please select a shop user"],
      unameRules: [(v) => !!v || "User name is required"],
      emailRules: [(v) => !!v || "Email is required"],
      passwordRules: [(v) => !!v || "Password is required"],
    };
  },
  created() {},
  computed: {
    isOpenDialog() {
      return this.dialog;
    },
  },
  watch: {
    isOpenDialog(isOpen) {
      if (isOpen) {
        this.$api.getShopClasses().then((response) => {
          if (response.data.status == "success") {
            this.shopClass = response.data.classes;
          } else {
            console.log("failed to load");
          }
        });
        this.$api.getDistributors().then((response) => {
          if (response.data.status == "success") {
            this.distributors = response.data.distributors;
          } else {
            console.log("failed to load");
          }
        });
        this.$api.getLocations().then((response) => {
          if (response.data.status == "success") {
            this.locations = response.data.areas;
          } else {
            console.log("failed to load");
          }
        });
        this.$api.getTypeUsers().then((response) => {
          if (response.data.status == "success") {
            this.user = response.data.users;
          } else {
            console.log("failed to load");
          }
        });
        this.$api.getGeneratedShopCode().then((response) => {
          if (response.data.status == "success") {
            this.form.code = response.data.code;
          } else {
            console.log("failed to load");
          }
        });
      }
    },
  },
  methods: {
    createShop() {
      if (this.$refs.shopForm.validate()) {
        this.$api.saveShop(this.form).then((response) => {
          if (response.data.status == "success") {
            this.snackbar = true;
            this.closeDialog();
            // this.$emit("update:dialog", false);
          } else {
            console.log("failed to save");
          }
        });
      } else {
        console.log("failed to validate");
      }
    },
    handleOpenAddLocation() {
      this.addLocationDialog = true;
    },

    openUserForm() {
      this.isUserModal = true;
    },
    handleAddUser() {
      if (this.$refs.formUser.validate()) {
        this.$api.saveUser(this.userm).then((response) => {
          if (response.data.status == "success") {
            this.$api.getTypeUsers().then((response) => {
              if (response.data.status == "success") {
                this.user = response.data.users;
              } else {
                console.log("failed to load");
              }
            });
            this.snackbaruser = true;
            this.isUserModal = false;
            this.form.user_id = response.data.user.id;

            // this.$emit("update:dialog", false);
          } else {
            this.snackuservalid = true;
          }
        });
      } else {
        console.log("failed to validate");
      }
    },

    closeDialog() {
      this.$emit("update:dialog", false);
      this.form = {};
      this.user = [{}];
      this.shopClass = [{}];
      this.distributors = [{}];
      this.locations = [{}];
    },
  },
};
</script>
<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 0px;
  z-index: 2;
  border-radius: 0 !important;
}
</style>
